module.exports = __webpack_public_path__ + "static/media/pickup.f1ab5e67.svg";